import React, { useEffect, useState } from 'react';
import {
  Modal, Text, Button, Group, Stack, Checkbox,
} from '@mantine/core';
import WebTemplatesPanel from '../../../components/RightSide/WebTemplatesPanel';
import { fetchWebTemplatesForDocument } from '../../requests/webTemplates';
import { KIND_DEFAULT } from '../../utils/webTemplateKind';

const WebTemplatePicker = ({
  opened,
  onClose,
  onGenerate,
  documentIdentity = null,
  loading,
  modalTitle = 'Choisir un template web',
  primaryButtonLabel = 'Générer le site',
  description,
  destructive = false,
  reviewStylesOption = false,
}) => {
  const [selectedId, setSelectedId] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [reviewStyles, setReviewStyles] = useState(false);

  useEffect(() => {
    if (!opened) return;
    setSelectedId(null);
    setConfirmed(false);
    setReviewStyles(false);
  }, [opened]);

  const handleGenerate = () => {
    if (!selectedId) return;
    onGenerate(selectedId, { reviewStyles });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={modalTitle}
      size="xl"
    >
      <Stack gap="md">
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
        {/* Même tableau que le choix d'un modèle classique ou d'un site web
            seul : la modale ne le monte qu'ouverte, il recharge donc la liste
            à chaque ouverture. */}
        <div style={{ height: 420, display: 'flex', flexDirection: 'column' }}>
          <WebTemplatesPanel
            fetchTemplates={() => fetchWebTemplatesForDocument(documentIdentity, KIND_DEFAULT)}
            onApply={setSelectedId}
          />
        </div>

        {reviewStylesOption && (
          <Checkbox
            checked={reviewStyles}
            onChange={(e) => setReviewStyles(e.currentTarget.checked)}
            label="Revoir les styles du document"
            description="Choisir à nouveau le style du site que prend chaque style du document, même ceux déjà associés."
          />
        )}

        {destructive && (
          <Checkbox
            checked={confirmed}
            onChange={(e) => setConfirmed(e.currentTarget.checked)}
            color="red"
            label="Je comprends que cette action écrase les modifications faites sur les pages générées"
          />
        )}

        <Group justify="flex-end" mt="sm">
          <Button variant="default" onClick={onClose} disabled={loading}>
            Annuler
          </Button>
          <Button
            color={destructive ? 'red' : undefined}
            onClick={handleGenerate}
            disabled={!selectedId || (destructive && !confirmed)}
            loading={loading}
          >
            {primaryButtonLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default WebTemplatePicker;
